import { useDrop } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { DRAG_ITEM_TYPES } from 'src/constants/dragItem';
import type { DragItem } from 'src/types/workspace';
import { useWorkspaceContext } from 'src/components/workspace/WorkspaceContext';

import { styles } from './index.styles';

export const ADD_TO_ALL_TEST_ID = 'add-to-all';

const WorkspaceAddToAllDropTarget = () => {
  const { t } = useTranslation('workspace');
  const { addShapingToAllDefinitionLines, setShowLoadingIndicator } =
    useWorkspaceContext();

  const [{ isOver, canDrop }, WorkspaceAddToAllDropTargetElement] = useDrop({
    accept: [DRAG_ITEM_TYPES.SHAPING, DRAG_ITEM_TYPES.ORG_UNIT],

    drop: (item: DragItem) =>
      setShowLoadingIndicator(
        true,
        addShapingToAllDefinitionLines.bind(null, item),
      ),

    collect: (monitor) => ({
      isOver: monitor.isOver(),
      item: monitor.getItem(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <Box
      sx={styles.dropDownTarget}
      ref={WorkspaceAddToAllDropTargetElement}
      data-test-id={ADD_TO_ALL_TEST_ID}
    >
      <Box sx={styles.title}>{t('addToAll')}</Box>
      <Box sx={styles.arrow(canDrop, isOver)}>{t('dropHere')}</Box>
    </Box>
  );
};

export default WorkspaceAddToAllDropTarget;
